// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DGClN","rightAdornment":"Header_rightAdornment__2Mgq2"};